import {
  IMAGE_ACTION,
  IMAGE_MODE,
  IMAGE_MODEL_ID,
  PROVIDER,
} from 'Pods/ThreeDStudio/Store/constants'

export default {
  "model_id": IMAGE_MODEL_ID.FAL_BACKGROUND_REMOVAL_BRIA_RMBG2,
  "provider": PROVIDER.FAL,
  "action": IMAGE_ACTION.BACKGROUND_REMOVAL,
  "mode": IMAGE_MODE.BRIA_RMBG2,
  "input_schema": {
    "type": "object",
    "properties": {
      "input_image": {
        "type": "array",
        "minItems": 1,
        "maxItems": 1,
        "items": {
          "type": "object",
          "properties": { "asset_id": { "type": "integer" } },
          "required": ["asset_id"],
        },
      },
    },
    "required": ["input_image"],
  },
  "ui_schema": {},
}
